import { render, staticRenderFns } from "./handicaps.vue?vue&type=template&id=48c201b6&scoped=true"
import script from "./handicaps.vue?vue&type=script&lang=js"
export * from "./handicaps.vue?vue&type=script&lang=js"
import style0 from "./handicaps.vue?vue&type=style&index=0&id=48c201b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c201b6",
  null
  
)

export default component.exports